module.exports = __webpack_public_path__ + "static/media/lobalSchoalrs.8932b7ac.png";